__turbopack_context__.v({
  "editableTaskTitle": "wZa-0W_editableTaskTitle",
  "editableTaskTitle__button": "wZa-0W_editableTaskTitle__button",
  "editableTaskTitle__input": "wZa-0W_editableTaskTitle__input",
  "editableTaskTitle__readonly": "wZa-0W_editableTaskTitle__readonly",
});
